export enum HiLoGameMode {
	Standard,
	Leaderboard,
	Millionaire
}
